import { render, staticRenderFns } from "./PagePasswordLost.vue?vue&type=template&id=fd2009fc&scoped=true&"
import script from "./PagePasswordLost.vue?vue&type=script&lang=js&"
export * from "./PagePasswordLost.vue?vue&type=script&lang=js&"
import style0 from "./PagePasswordLost.vue?vue&type=style&index=0&id=fd2009fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2009fc",
  null
  
)

export default component.exports